import { Tile, TileHeader } from '@creditflowresearch/uilib/Tile';
import Title from '@creditflowresearch/uilib/Title';
import Flex from '@creditflowresearch/uilib/Flex';
import TraceTable from '@/creditflowresearch/ui/components/trace/common/TraceTable';
import SearchInput from '@/creditflowresearch/ui/components/trace/common/SearchInput';
import FiltersButton from '@/creditflowresearch/ui/components/trace/common/FiltersButton';

import styles from '@/creditflowresearch/ui/components/trace/trace.module.scss';

interface ITraceTableContainerProps {
  onFiltersClick: () => void,
}

const TraceTableContainer = ({ onFiltersClick }: ITraceTableContainerProps) => (
  <Tile dataTest="traceTableContainer">
    <TileHeader
      title={ <Title title="TRACE" /> }
      dataTest="traceTableHeader"
    >
      <Flex
        direction={ { sm: 'column-reverse', md: 'column-reverse', xl: 'row' } }
        align={ { sm: 'stretch', md: 'stretch', xl: 'center' } }
        gap={ 10 }
      >
        <SearchInput size="S" className={ styles.searchInput } />
        <FiltersButton
          className={ styles.filtersButton }
          onClick={ onFiltersClick }
        />
      </Flex>
    </TileHeader>
    <TraceTable isItemsPerPageVisible />
  </Tile>
);

export default TraceTableContainer;
